import PropTypes from 'prop-types';
import React from 'react';

const months = [];
const years = [];
const addZero = i => {
  if (i < 10) {
    return `0${i}`;
  }
  return i.toString();
};
const addYear = i => (new Date().getFullYear() + i).toString();

for (let i = 1; i <= 12; i += 1) {
  months.push({ value: addZero(i), text: addZero(i) });
  years.push({ value: addYear(i - 1), text: addYear(i - 1) });
}
const InputMonthYear = ({ label, error, month, year, isDisabled }) => (
  <div className={'ccfp__content__form__input-month-year'}>
    <div
      className={`ccfp__content__form__input-month-year__label ${
        error ? 'ccfp__content__form__input-month-year__label--has-error' : ''
      }`}
    >
      <label htmlFor={name}>{label}</label>
    </div>
    <div className={'ccfp__content__form__input-month-year__group'}>
      <div className={'wrapper'}>
        <div className={'month'}>
          <select
            onChange={e => month.onChange(e)}
            name={month.name}
            id={month.name}
            value={month.value}
            disabled={isDisabled}
          >
            <option value={''} disabled>
              {month.label}
            </option>
            {months.map((option, index) => (
              <option value={option.value} key={index}>
                {option.text}
              </option>
            ))}
          </select>
        </div>
        <div className={'year'}>
          <select
            onChange={e => year.onChange(e)}
            name={year.name}
            id={year.name}
            value={year.value}
            disabled={isDisabled}
          >
            <option value={''} disabled>
              {year.label}
            </option>
            {years.map((option, index) => (
              <option value={option.value} key={index}>
                {option.text}
              </option>
            ))}
          </select>
        </div>
      </div>
      <p className={'error-text'}>{error}</p>
    </div>
  </div>
);

InputMonthYear.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  month: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
  }).isRequired,
  year: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
  }).isRequired,
  isDisabled: PropTypes.bool,
};

export default InputMonthYear;
